import { safeStorage } from './storage';

/** The left panel keeps the key it had before other panels remembered their layout. */
const layoutKey = (panel: string) =>
  panel === 'left' ? 'draw:panel-layout' : `draw:${panel}-panel-layout`;

export interface PanelLayout {
  readonly shown?: string;
  readonly collapsed: boolean;
  readonly width?: number;
}

/** Per-browser layout choices, kept apart from drawings. */
export class LocalPreferences {
  constructor(private readonly storage: Storage | null = safeStorage()) {}

  panelLayout(panel: string): PanelLayout | null {
    const text = this.storage?.getItem(layoutKey(panel));
    if (!text) return null;
    try {
      const { shown, collapsed, width } = JSON.parse(text) as Partial<PanelLayout>;
      return {
        ...(typeof shown === 'string' ? { shown } : {}),
        collapsed: collapsed === true,
        ...(typeof width === 'number' ? { width } : {}),
      };
    } catch {
      return null;
    }
  }

  setPanelLayout(panel: string, layout: PanelLayout): void {
    this.storage?.setItem(layoutKey(panel), JSON.stringify(layout));
  }
}
